<template>
    <v-text-field v-bind="$props" v-on="$listeners">
       
    </v-text-field>
</template>

<script>
    import { VTextField } from 'vuetify/lib'

    export default {
        name: 'TextField',
        extends: VTextField,

        model: {
            prop: 'value',
            event: 'change'
        },
    }
</script>

<style>
</style>